/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chartlegendlabel2Inputs */

const en_chartlegendlabel2 = /** @type {(inputs: Chartlegendlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show or hide series`)
};

const de_chartlegendlabel2 = /** @type {(inputs: Chartlegendlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihen ein- oder ausblenden`)
};

/**
* | output |
* | --- |
* | "Show or hide series" |
*
* @param {Chartlegendlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const chartlegendlabel2 = /** @type {((inputs?: Chartlegendlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chartlegendlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chartlegendlabel2(inputs)
	return de_chartlegendlabel2(inputs)
});
export { chartlegendlabel2 as "chartLegendLabel" }